export default {
  'vi-vn': {
    flag: 'vietnam',
    shopManagement: '매장관리자',
    estimatedPaymentAmount: '결제 예상금액',
    common: {
      search: '검색',
    },
    footer: {
      address: 'Ergosleep Building 3F, Nonhyeon-ro 721 Gangnam-gu, Seoul, Korea',
      customerService: 'Customer Service 822-1577-0564',
      companyNameKorean: 'B1SOFT CO.,LTD',
      companyCeoName: 'CEO: Choi Seok Woong',
      businessLicenseNumberText: 'Business License Number',
      businessLicenseNumber: '816-87-01138',
      companyNameEnglish: 'B1SOFT., LTD B1SOFT',
    },
    currency: {
      kr: {
        text: 'KRW',
        symbol: '₩',
      },
      us: {
        text: 'USD',
        symbol: '$',
      },
    },
    grade: {
      Rookie: '루키',
      Beginner: '비기너',
      Amateur: '아마추어',
      SemiPro: '세미프로',
      Pro: '프로',
      TourPro: '투어프로',
      Challenger: '챌린저',
    },
    gender: {
      man: '남자',
      woman: '여자',
      unLimit: '제한없음',
    },
    menu: {
      shopInfoManagement: '매장 정보 관리',
      gameRoundOptionOptionManagement: '게임 옵션 관리',
      drivingRangeOptionOptionManagement: '연습장 옵션 관리',
      realtimeControlOptionManagement: '실시간 제어 옵션 관리',
      agreement: '약관',
      signOut: '로그아웃',
    },
    signIn: {
      id: '아이디',
      password: '비밀번호',
      forgotId: '아이디 찾기',
      forgotPassword: '비밀번호 찾기',
      rememberMe: '로그인 상태 유지',
      buttonSignIn: '로그인',
      cookie: '쿠키 삭제',
      cookieMessage: '쿠키를 삭제 하였습니다.',

      fail: 'Đăng nhập thất bại. Vui lòng thử lại.',
    },
    notification: {
      title: '알림',
      no: '번호',
      roomName: '타석이름',
      callTime: '호출시간',
      message: '메시지',
      confirm: '확인',
      noNotificationMSG: '호출된 알림 메시지가 없습니다.',

      billing_automatic_payment_failed: '[K-Golf 자동결제 실패 안내] K-Golf 자동결제가 실패하였습니다. ${payment_date} 일 이후 타석에서 연습장을 제외한 다른 컨텐츠를 이용 하실 수 없습니다. 자동결제 미납분 결제 및 기타 사항에 대해서는 고객센터에 문의하시기 바랍니다. [고객센터] ${customer_center_number}',
      billing_automatic_payment_guide: '[K-Golf 자동결제 안내] K-Golf 자동결제가 ${payment_date} 에 예정입니다. 계좌 상태를 확인 하시기 바랍니다. 자동결제 예정일에 결제가 완료되지 않으면, 자동결제일 이후 타석에서 연습장을 제외한 다른 컨텐츠를 이용 하실 수 없습니다. [고객센터] ${customer_center_number}',
      billing_automatic_payment_success: '[K-Golf 자동결제 완료 안내] K-Golf 자동결제가 완료되었습니다.',
      billing_content_restrictions_notice: '[K-Golf 이용정지 안내] K-Golf 결제일 이내 결제가 진행되지 않아,${payment_date} 이후 타석에서 연습장을 제외한 다른 컨텐츠를 이용 하실 수 없습니다. 미납금액 결제 및 기타사항 에 대해서는 고객센터에 문의하시기 바랍니다. [고객센터] ${customer_center_number}',
      billing_manual_payment_guide: '[K-Golf 일반결제 기간 안내] ${start_date} ~ ${end_date} 까지 (${diff_day}일간) 해당 기간안에 결제를 진행하지 않으면, 결제일 이후 타석에서 연습장을 제외한 다른 컨텐츠를 이용 하실 수 없습니다. [고객센터] ${customer_center_number}',

      game_client_additional_access_game_round_approval_failed: '${client_name}의 라운드 추가 이용 승인 명령 전송이 실패 하였습니다.',
      game_client_additional_access_game_round_request: '${client_name}에서 라운드 추가 이용을 요청 하였습니다.',
      game_client_additional_access_game_round_request_reject: '${client_name}의 라운드 추가이용 요청을 거절 하였습니다.',

      game_client_cancel_shot_failed: '${client_name}의 마지막 샷 취소에 실패했습니다.',
      game_client_cancel_shot_failed_2: '플레이어의 샷 취소 횟수를 모두 사용했습니다.',
      game_client_cancel_shot_failed_3: '게임이 진행 중입니다. 샷 취소에 실패했습니다.',
      game_client_cancel_shot_failed_4: '취소 가능한 샷이 없습니다.',
      game_client_cancel_shot_success: '${client_name}의 마지막 샷 취소를 성공했습니다.',

      game_client_extended_wait_success: '${client_name}이 대기상태로 변경 되었습니다.',

      game_client_force_disconnection_failed: '${client_name}의 연결 강제 해제 명령 전송이 실패 하였습니다.',
      game_client_force_disconnection_success: '${client_name}의 연결 강제 해제가 성공적으로 완료되었습니다.',

      game_client_guest_login_failed: '${client_name}에 게스트 로그인이 명령 전송이 실패 하였습니다.',
      game_client_guest_login_success: '${client_name}에 게스트 로그인이 성공 하였습니다.',

      game_client_limit_change_failed: '${client_name}의 제어옵션 변경 내역 전송이 실패 하였습니다.',
      game_client_limit_change_success: '${client_name}의 제어옵션이 변경되었습니다.',

      game_client_lock_failed: '${client_name}에 잠금 명령 전송이 실패 하였습니다.',
      game_client_lock_success: '${client_name}이 잠금상태로 변경 되었습니다.',

      game_client_player_count_change_failed: '${client_name}의 이용인원 변경 명령 전송이 실패 하였습니다.',
      game_client_player_count_change_request_reject: '${client_name}에서 이용인원 제한 수 변경 요청을 거절 하였습니다.',
      game_client_player_count_change_success: '${client_name}의 이용인원이 ${n}명에서 ${player_count}명으로 변경 되었습니다.',

      game_client_reset_mulligan_failed: '${client_name}의 멀리건 횟수 초기화에 실패했습니다.',
      game_client_reset_mulligan_success: '${client_name}의 멀리건 횟수 초기화에 성공했습니다.',

      game_client_shop_manager_call_request: '${client_name}에서 매장관리자를 호출 하였습니다.',

      game_client_time_extension_failed: '${client_name}의 이용시간 추가 명령 전송이 실패 하였습니다.',
      game_client_time_extension_request: '${client_name}에서 이용시간 연장을 요청 하였습니다.',
      game_client_time_extension_request_reject: '${client_name}의 이용시간 연장 요청을 거절 하였습니다.',
      game_client_time_extension_success_1: '${client_name}의 이용시간이 ${add_time}분 연장되었습니다.',

      game_client_unlock_failed: '${client_name}에 잠금해제 명령 전송이 실패 하였습니다.',
      game_client_unlock_success: '${client_name}의 잠금이 해제 되었습니다.',

      game_client_user_login_failed: '${client_name}의 사용자 로그인이 명령 전송이 실패 하였습니다.',
      game_client_user_login_success: '${client_name}의 사용자 로그인이 성공하였습니다.',

      kms_notice: '${title}',

      quit_game_client_failed: '${client_name}의 종료 요청에 실패 했습니다.',
      quit_game_client_success: '${client_name}의 종료 요청에 성공 했습니다.',

      run_game_client_failed: '${client_name}의 실행 요청에 실패 했습니다.',
      run_game_client_success: '${client_name}의 실행 요청에 성공 했습니다.'
    },
    dashboard: {
      content: '대한민국 대쉬보드',
    },
    gameHistory: {
      searchPeriod: '검색 기간',
      userNickname: '회원 닉네임',
      userNicknamePlaceholder: '닉네임을 입력해주세요.',
      search: '검색',
      gameType: '게임 타입',
      shopClient: '타석',
      all: '전체',
      gameHistoryStatistics: '게임 내역 통계',
      gameHistoryStatisticsNoticeText: '( 검색 기준에 따른 통계 정보 입니다. )',
      gameMode: '게임 모드',
      normalGame: '일반 게임',
      drivingRange: '연습장',
      swingDiagnosis: '스윙 진단',
      userType: '회원 구분',
      user: '회원',
      guest: '게스트',
      gender: '성별',
      male: '남성',
      female: '여성',
      times: '회',
      gameRoundList: '게임 라운드 목록',
      gameNumbers: '게임 번호',
      clientName: '타석명',
      numberPlayers: '플레이어 수',
      numberHolesCompleted: '완료 홀 수',
      startDate: '시작 시간',
      endDate: '종료 시간',
      more: '더보기',
      close: '접기',
      download: '다운로드',
      alert: {
        message1: '타석은 최소 1개는 선택되어 있어야 합니다.',
        message2: '게임 타입은 최소 1개는 선택되어 있어야 합니다.',
        message3: '기간은 최대 3개월까지만 선택할 수 있습니다.',
        message4: '검색 데이터 양에 따라 지연될 수 있습니다.\n진행하시겠습니까?',
        message5: 'No data',
      },
    },
    clientStatus: {
      sendMessage: '메세지 전송',
      statusInfo: '상태 정보',
      proceeding: '진행중',
      endUse: '이용 종료',
      blind: '잠금',
      lobby: '로비',
      clientOff: '클라이언트 꺼짐',
      course: 'Course',
      playerCount: '플레이어 수',
      remainingTime: '남은시간',
      start: '시작',
      paymentType: '결제 방법',
      usageModeSetting: '이용 모드 설정',
      gameType: '게임 타입',
      usageTimeSetting: '이용 시간 설정',
      holeType: '홀 타입',
      drivingRangeTime: '연습 시간',
      noLimit: '제한없음',
      stroke: '게임',
      drivingRange: '연습',
      minutes: '분',
      lessThanMinute: '1분 미만',
      paymentProgress: '후불 진행중',
      peopleCount: '명',
      noDrivingRange: '없음',
      status: '상태',
      usageTime: '이용시간',
      usageCourse: '이용코스',
      usagePeopleCount: '사용인원',
      addGuest: '게스트 추가',
      extendedTime: '시간 연장',
      scorecard: '스코어카드',
      changeSetting: '설정 변경',
      resetMulligan: '멀리건 초기화',
      cancelShot: '샷 캔슬',
      bilnd: '잠금',
      currentHole: '현재 홀',
      sound : 'Âm thanh',
      clientType : '타석구분',
      popup: {
        close: '닫기',
        addGuest: {
          addGuest: '게스트 추가',
          guestNicknamePlaceholder: '게스트 닉네임을 입력해주세요.',
          cancel: '취소',
        },
        sendMessage: {
          sendMessage: '메시지 전송',
          all: 'ALL',
          cancel: '취소',
          messagePlaceholder: '전송할 메시지 내용을 입력해 주세요.',
        },
        extendedTime: {
          extendedTime: '시간 연장',
          minutes: '분',
          addServiceTime: '서비스 시간 충전',
          cancel: '취소',
        },
        changeSetting: {
          changeSetting: '설정 변경',
          cancel: '취소',
        },
      },
      alert: {
        message1: '결제 방법을 선택해주세요.',
        message2: '이용 시간 설정을 선택해주세요.',
        message3: '이용 모드 설정을 선택해주세요.',
        message4: '게임 타입을 선택해주세요.',
        message5: '홀 타입을 선택해주세요.',
        message6: '플레이어 수를 선택해주세요.',
        message7: '연습 시간을 선택해주세요.',
        message8: '타석의 화면을 잠금 처리 하시겠습니까?',
        message9: '잠시 후 다시 시도해주시기 바랍니다.',
        message10: '현재 진행중인 게임의 멀리건을 초기화 하시겠습니까?',
        message11: '게임 라운드 ID 정보가 없으므로 멀리건 초기화를 요청할 수 없습니다.',
        message12: '타석 제어 설정을 변경하시겠습니까?',
        message13: '게임 라운드 설정을 변경하시겠습니까?',
        message14: '메시지를 전송할 타석을 선택해주세요.',
        message15: '메시지를 입력해주세요.',
        message16: '해당 타석은 후불이므로 시간을 연장할 수 없습니다.',
        message17: '연장할 시간을 다시 선택해주세요.',
        message18: '게스트 닉네임을 입력해주세요.',
        message19: '로그인 가능한 인원수가 부족하여 게스트 로그인 요청을 할 수 없습니다.',
        message20: 'Unable to process the shot cancellation request as the game round ID information is missing.',

        message1000: '게임 라운드 설정 변경 기능은 준비 중입니다.',
      },
    },
    billing: {
      tossPay: {
        addressTitle: 'Shipping address',
        clearAddressButton: 'Clear address',
        clearAddressTooltip: 'Keep recipient/phone, clear address only',
        recipientPlaceholder: 'Recipient',
        phonePlaceholderKrw: 'Phone (e.g., 010-1234-5678)',
        phonePlaceholderIntl: 'Phone (country code allowed)',
        postcode: 'Postal code',
        searchAddressButton: 'Find address',
        address1Krw: 'Primary address',
        address2Krw: 'Detail address (Dong/Unit)',
        address1Intl: 'Address line 1',
        searchHint: 'Search…',
        address2Intl: 'Address line 2 (Apt, Unit, etc.)',
        country: 'Country',
        city: 'City',
        state: 'State / Province / Region',
        postalIntl: 'Postal code / ZIP',
        saveNoteKrw: '※ Shipping address will be saved with payment.',
        saveNoteIntl: '※ Your shipping address will be saved with your payment.',
        fedexTitle: 'FedEx Account',
        fedexPlaceholder: 'Enter your FedEx account number',
        fedexNote: '※ Required for collect (recipient-billed) shipments.',
        // ▼ added
        fedexHelpTitle: 'Don’t have a FedEx account?',
        fedexHelpDesc: 'Create one using the links below.',
        fedexGlobalLink: 'Open FedEx Account (Global)',
        fedexUSLink: 'Open FedEx Account (US)',
        fedexGuideLink: 'How do I create a FedEx account? (FAQ)',
        paymentMethodsTitle: 'Payment method',
        agreeRequired: 'You must agree to the Terms of Service and Privacy Policy.',
        enterShipping: 'Please enter your shipping address.',
        enterFedex: 'Please enter your FedEx Account.',
        payNow: 'Pay now',
        cardLabel: 'Credit Card',
        paypalLabel: 'PayPal',
        alipayLabel: 'Alipay',
      }
      ,
      paymentInfo: {
        ownerDefaultInfo: '매장주 기본 정보',
        shopName: '매장명',
        shopOwnerName: '매장주 이름',
        shopAddress: '매장 주소',
        shopAddressChangeNoticeText: '매장 주소 변경을 원하시는 경우 K-Golf 고객센터에 연락해 주시기 바랍니다.',
        receiveBillInfoChange: '명세서 정보 변경',
        receiveBillInfoChangeNoticeText: '매달 K-Golf 이용시 발생하는 요금에 대한 명세서를 수신',
        shopOwnerMobilePhone: '매장주 연락처',
        editButton: '수정하기',
        mobileBill: '모바일 명세서 (MMS)',
        mobileBillNoticeText: '매달 이용요금 명세서를 등록된 매장주 연락처로 발송합니다.',
        sendButton: '발송',
        shipsFirstDayEveryMonth: '매달 1일 발송',
        mobileBillNoAuth: '인증되지 않았습니다. 모바일 인증을 하지 않으면, 결제관련 명세서를 받을 수 없습니다.',
        shopOwnerEmail: '매장주 이메일',
        authenticateButton: '인증하기',
        emailBill: '이메일 명세서',
        emailBillNoticeText: '매달 이용요금 명세서를 등록된 매장주 이메일로 발송합니다.',
        emailBillNoAuth: '인증되지 않았습니다. 이메일 인증을 하지 않으면, 결제관련 명세서를 받을 수 없습니다.',
      },
      recurringPayment: {
        noRecurringPaumentServiceNoticeText1: '정기결제 서비스에 등록되어 있지 않은 매장입니다.',
        noRecurringPaumentServiceNoticeText2: '정기결제 관리는 정기결제 서비스가 등록되어야 열람이 가능 합니다.',
        agreementToUseRecurringPaymentService: '정기결제 서비스 이용 동의',
        guide: '정기결제서비스 등록가이드',
        whatIsRecurringPaymentService: '정기결제 서비스 란?',
        recurringPaymentServiceDescription:
          '본사 (주)케이골프에서 지정한 결제일에 매월 자동으로 결제금액을 출금하는 서비스입니다. 정기결제 서비스를 이용하는 경우에는 최대 결제금액의 2.0%의 요금 할인이 있습니다.',
        agreeTermsConditionsRecurringPayment: '정기결제 이용약관 동의',
        allAgreement: '전체 동의',
        required: '필수',
        termsOfRecurringPaymentService: '정기결제 서비스 이용 약관 동의',
        personalInformationProvidedThirdParties: '개인정보 제 3자 제공 동의',
        entrustingHandlingOfPersonalInformation: '개인정보 취급 위탁 동의',
        useAgreementButtonText: '정기결제 서비스 이용 약관 동의',
        useAgreementNoticeText: '정기결제 이용 약관에 동의해주시기 바랍니다.',
        recurringPaymentService: '정기결제 서비스',
        status: '상태',
        statusApplyingText: '신청중',
        statusUseText: '이용중',
        serviceStartDate: '서비스 시작일',
        automaticPaymentDueDate: '자동 결제 예정일',
        discountRate: '할인율',
        recurringPaymentServiceCancel: '정기결제 서비스 이용 취소',
        bankAccountRegistrationAndManagement: '계좌 등록 및 관리',
        bankAccount: '계좌',
        bankAccountNumber: '계좌 번호',
        bankAccountName: '계좌명',
        management: '관리',
        addBankAccount: '계좌 등록',
        deleteBankAccount: '계좌 삭제',
        noBankAccountNoticeText: '등록된 계좌가 없습니다.<br />우측의 계좌 등록 버튼을 눌러 계좌 등록을 진행하시기 바랍니다.',
        creditCardRegistrationAndManagement: '카드 등록 및 관리',
        creditCard: '카드',
        creditCardNumber: '카드 번호',
        noCreditCardNoticeText: '등록된 카드가 없습니다.<br />우측의 카드 등록 버튼을 눌러 카드 등록을 진행하시기 바랍니다.',
        addCreditCard: '카드 등록',
        deleteCreditCard: '카드 삭제',
        recurringPaymentNoticeText: '자동결제 서비스에 계좌 및 카드가 모두 등록되어 있는 경우 <strong>계좌를 우선</strong>으로 결제 서비스를 진행 합니다.<br />해당 계좌에 출금 가능 금액이 부족한 경우 신용카드로 결제를 시도합니다.',
      },
      paymentProgress: {
        text1: '결제정보를 확인하고 있습니다.',
        text2: '잠시만 기다려 주세요.',
      },
      paymentComplete: {
        text1: '결제 성공',
        text2: '(For virtual account payments, the service is available after the deposit is confirmed.)',
        buttonText: '완료',
      },
      paymentFail: {
        text1: '결제 실패',
        text2: '',
        buttonText: '닫기',
      },
      paymentCancel: {
        text1: '결제 취소',
        text2: '',
        buttonText: '닫기',
      },
      payment: {
        generalPayment: '일반 요금납부',
        prepayment: '결제 예정 금액 선결제',
        paymentUnpaidCharges: '미납 요금납부',

        chargesText: '납부하실 금액은 <span class="price">|charges|</span> <span style="font-size:26px;">|currency|</span> 입니다.',
        checkPaymentHistory: '납부 내역을 확인해주세요.',
        billingMonth: '청구월',
        amountBePaid: '납부하실 금액',
        details: '상세내역',
        choosePaymentMethod: '결제 방법을 선택해주세요.',
        realTimeAccountTransfer: '실시간 계좌이체',
        creditCardPayment: '신용카드 결제',

        tab1: {
          text1: '지금은 일반 요금납부가 가능한 기간이 아니거나,',
          text2: '납부할 금액이 존재하지 않습니다.',
          text3: '일반요금 납부 가능 기간',
          text4: '일반 요금납부는 매달 1일 부터 K-Golf 본사가 지정한 결제일 마감일 까지만 가능 합니다.',
          text5: '결제 마감일',
          text6: '일반 요금납부 가능기간',
          text7: '매달',
          text8: '일',
        },
        tab2: {
          text1: '지금은 선결제 가능한 기간이 아니거나,',
          text2: '결제할 금액이 존재하지 않습니다.',
          text3: '선결제 가능 기간',
          text4: '선결제는 매달 1일 부터 K-Golf본사가 지정한 결제일의 전전날 까지만 가능 합니다.',
          text5: '결제 마감일',
          text6: '일반 요금납부 가능기간',
          text7: '매달',
          text8: '일',
        },
        tab3: {
          text1: '미납 금액이 존재 하지 않습니다.',
          text2: '미납금액은 K-Golf 본사가 지정한 결제일 이후 부터 미납금액 결제가 가능 합니다.',
          text3: 'K-Golf 결제일',
          text4: '매달',
          text5: '일',
          text6: '선결제 납부 가능 기간',
          text7: '선결제는 매달 1일 부터 K-Golf본사가 지정한 결제일의 전전날 까지만 가능 합니다.',
          text8: '결제 마감일',
          text9: '선결제 가능 기간',
        },
      },
      bills: {
        monthPaymentAmount: '|month| 결제 금액',
        usagePeriod: '이용기간',
        clientName: '타석 이름',
        usageAmount: '이용금액',
        discountAmount: '할인금액',
        paymentAmount: '납부금액',
        contentPlan: '콘텐츠 상품',
        coursePlan: '코스 상품',
        minutes: '분',
        course: '코스',
        totalCharges: '소계',
        count: '개',
        coutseUnlimit: '제한없음',
        vat: '부가세',
        currentMonthTotalCharges: '이번달 요금 합계',
        totalAmount: '총 청구요금',
      },
      paymentHistory: {
        text1: '납부 내역은 최대 12개월 전 까지의 기록만 조회가 가능 합니다. 그 이전 내역을 원하시는 경우 본사에 연락 하시기 바랍니다.',
        billMonth: '명세서 발급월',
        charges: '청구 금액',
        paymentStatus: '납부 상태',
        paymentSuccess: '납부완료',
        unpayment: '미납부',
      },
      itemPaymentHistory: {
        info01: '영수증 확인은 아이템 구매시 입력한 e-mail에서 확인 하세요.',
        info02: '환불 요청은 고객센터에 문의 주세요.',
        date: '구매 일자',
        orderNumber: '주문 넘버',
        purchaseItem: '구매 항목',
        charges: '결제 금액',
        paymentMethod: '결제 수단',
        materialCode: 'Material Code',
        quantity:     'Quantity',
        paymentMethods: {
          CA:              'Credit Card',
          AccountTransfer: 'Account Transfer',
          PZ:              'PayZ',
          EASYPAY:         'Easy Pay',
        },
        statuses: {
          0: 'Preparing',
          1: 'Shipped',
          2: 'Delivered',
          3: 'Refunded',
        },
      },
    },
    customerService: {
      notice: {
        postType: '분류',
        searchPlaceholder: '제목 + 내용',
        postTitle: '제목',
        registrationDate: '등록일자',
        attachments: '첨부파일',
        moveListButtonText: '목록',
        postTypeCode: {
          notice: '공지사항',
          update: '업데이트',
          event: '이벤트',
        },
      },
      qna: {
        test: 'test',
      },
    },
    edit: {
      shopInfoSetting: {
        clientTypeAlert: '타석타입은 무조건 하나 이상 체크되어야 합니다.',

        shopInfo: '매장 정보',
        shopName: '매장명',
        shopPhoneNumber: '매장 전화번호',
        shopAddress: '매장 주소',
        shopOwnerName: '매장주 이름',
        shopOwnerMobilePhone: '매장주 전화번호',

        shopSalesInfo: '매장 영업 정보',
        operatingTime: '운영시간',
        operatingTimePlaceholder: '예시) \n평일 AM 08:00 ~ PM:12:00 \n주말/공휴일 AM 06:00 ~ PM 12:00',
        screen: '스크린',
        practiceRange: '연습장',
        lesson: '레슨',
        convenientFacilities: '편의시설',
        swingPlate: '스윙플레이트',
        leftHanded: '양타',
        parking: '주차',
        equipmentStorage: '장비보관',
        proLesson: '프로레슨',
        fee: '이용요금',
        feePlaceholder: '예시) \n자세한 요금은 매장에 문의하세요',
        storeView: '매장전경',
        parkingNotice: '주차안내',
        parkingPlaceholder: '예시) \n무료주차 (빌딩 주차장 이용)',
        storeIntroduce: '매장소개',
        storeIntroducePlaceholder: '예시) \n누구나 편안하게 골프를 즐길 수 있도록 노력하겠습니다. \n찾아주셔서 늘 감사합니다.',
        clientList: '타석 리스트',
        clientName: '타석 이름',
        clientOrder: '타석 순서',
        clientInfo: '타석 정보',
        clientType: '타석 타입',
        cancel: '취소',
        saveChanges: '변경내용 저장',
      },
      shopGameRoundOptionSetting: {
        title: '게임 옵션 관리',
        concede: '컨시드',
        holecupPosition: '홀컵 위치',
        mulliganCount: '멀리건 횟수',
        swingPlate: '스윙 플레이트',
        distanceUnit: '거리 단위',
        greenPosition: '그린 위치',
        greenSpeed: '그린 스피드',
        windStrength: '바람 세기',
        puttingLine: '퍼팅라인',
        bestVideo: '베스트 영상',
        continuePutting: '퍼팅 이어하기',
        caddyVoice: '캐디 음성',
        noPuttMode: 'PUTT SKIP',
        obTeeAndHazardTee: '오비 티, 해저드 티',
        on: '켜기',
        off: '끄기',
        saveChanges: '변경내용 저장',
        shotInfoLocation: '샷 정보 위치',
        side: '측면',
        bottom: '하단',
        greenHardness: '그린 경도',
        guideDistance: '공략 거리',
        maxScoreFactor: '홀 최대 타수',
      },
      shopDrivingRangeOptionSetting: {
        title: '연습장 옵션 관리',
        course: '코스',
        drivingRange1: 'KGOLF',
        drivingRange2: '장가계',
        drivingRange3: '센토사',
        drivingRange4: '히든캐슬',
        drivingRange5: 'KGOLF2',
        difficulty: '난이도',
        teeHeight: '티높이',
        windStrength: '바람 세기',
        distanceUnit: '거리 단위',
        swingPlate: '스윙 플레이트',
        ballTrajectory: '볼궤적',
        fixedCamera: '고정카메라',
        swingVideo: '스윙영상',
        on: '켜기',
        off: '끄기',
        saveChanges: '변경내용 저장',
      },
      shopClientRealTimeControlOptionSetting: {
        title: '타석 실시간 제어 옵션 기본값 설정',
        paymentType: '결제 방식',
        usageTimeSetting: '이용 시간 설정',
        usageModeSetting: '이용 모드 설정',
        noLimit: '제한 없음',
        stroke: '게임',
        drivingRange: '연습',
        usageContentSetting: '이용 컨텐츠 설정',
        availablePlayerCountSetting: '이용 가능 플레이어 인원 설정',
        holeType: '홀 타입',
        drivingRangeTime: '연습 시간',
        saveChanges: '변경내용 저장',
        peopleUnit: '명',
        none: '없음',
        minutes: '분',
      },
    },
    scorecard: {
      title: '스코어카드',
      gameNumbers: '게임 번호',
      gameType: '게임 타입',
      courseName: '코스명',
      gameHoleType: '게임 홀 타입',
      shopName: '매장명',
      shopClientName: '타석명',
      startTime: '시작 시간',
      endTime: '종료 시간',
      concede: '컨시드',
      holeCupPosition: '홀컵위치',
      mulligan: '멀리건',
      greenPosition: '그린 위치',
      greenSpeed: '그린 스피드',
      swingPlate: '스윙 플레이트',
      windStrength: '바람 세기',
      distanceUnit: '거리 단위',
      puttingLine: '퍼팅 라인',
      bestVideo: '베스트 영상',
      caddyVoice: '캐디 목소리',
      whetherUseObTeeAndHazardTee: '오비티, 해저드티 사용 여부',
      use: '사용',
      unused: '미사용',
      stroke: '스트로크',
      newPerio: '신페리오',
      ranking: '순위',
      team: '팀',
      nickname: '닉네임',
      handicap: '핸디캡',
      close: '닫기',
      alertText1: '아직 진행중인 게임 라운드입니다.',
      grade: '등급',
      greenHardness: '그린 경도',
      guideDistance: '공략 거리',
      maxScoreFactor: '홀 최대 타수',
      on: '켜기',
      off: '끄기',
    },
    alert: {
      comingSoon: '준비중입니다.',
      unusualApproach: '비정상적인 접근입니다.',
      deletePaymentMethodSuccess: '결제 방법을 성공적으로 삭제하였습니다.',
      deletePaymentMethodFail: '결제 방법 삭제를 실패하였습니다.',
      shopRecurringPaymentCancelSuccess: '매장 정기결제 서비스 이용 취소가 완료되었습니다.',
      shopRecurringPaymentCancelFail: '매장 정기결제 서비스 이용 취소를 실패하였습니다.',
    },
    popup: {
      title: {
        sendMessage: '메시지 전송',
        scorecard: '스코어카드',
        addGuest: '게스트 추가',
        extendedTime: '시간 연장',
        changeSetting: '설정 변경',
        courseSelection: '코스 설정',
        rankingCriteriaGameRoundCount: '게임 기록 많은 순이란?',
        rankingCriteriaBackCount: '백 카운트 방식이란?',
        shopTournamentOpenConfirm: '대회 개설 확인',
        shopTournamentModifyConfirm: '대회 수정 확인',

        deleteTournamentConfirm: '예정대회 삭제 안내',
        earlyEndTournamentConfirm: '대회 조기종료 안내',
        resetAwardsConfirm: '시상초기화 안내',
        awardRecipientsSelectionConfirm: '수상자 선정 확인',
        tournamentAwardAnnouncementConfirm: '수상자 발표 확인',
        contentsItemPayment: '콘텐츠 적용 안내',
        callNotification: '호출 알림',
      },
      button: {
        close: '닫기',
        cancel: '취소',
        confirm: '확인',
        announcement: '발표',
      },
    },
    agreement: {
      terms: '사업주 이용약관',
      privacy: '개인정보 처리방침',
      refund: 'Refund Policy',
      termsText:
          'This agreement defines the terms of system use between K-Golf, the developer and manufacturer of the screen golf system, and the business owner (store operator) who runs a for-profit business using the K-Golf system.\n\n' +
          'Article 1 (Purpose)\n' +
          'These terms and conditions ("Agreement") aim to define the rights, obligations, and responsibilities between the business owner and K-Golf Co., Ltd. ("Company") in relation to the use of services provided by the Company (screen golf service), internet-related services, and web and mobile services.\n\n' +
          'Article 2 (Definitions)\n' +
          '1. "Business Owner" refers to the owner of a business who operates a commercial store using K-Golf products approved by the Company.\n' +
          '2. "K-Golf Store" ("Business Location") refers to a store where the Business Owner has purchased and installed K-Golf products, and the Company has approved service provision.\n' +
          '3. "K-Golf Products" means the screen golf systems developed and produced by K-Golf.\n' +
          '4. "User Customer" refers to a customer who visits the business location, uses K-Golf products, and pays the usage fee according to the business location’s pricing policy.\n' +
          '5. "Billing" means the charges incurred when using games or paid content via K-Golf software.\n' +
          '6. "K-Golf Online Service" refers to all services provided to User Customers using K-Golf products at the business location (e.g., online course access, game records, events).\n' +
          '7. "K-Golf Online Service Fee" refers to the fee paid by User Customers for using the online golf course and is charged per use.\n' +
          '8. "Store Manager" refers to the software provided by the Company for Business Owners to manage K-Golf products online.\n\n' +
          'Article 3 (Game Billing Operation)\n' +
          '1. Billing methods are as follows:\n' +
          '  1) Online course use is billed per game and charged to the Business Owner.\n' +
          '  2) 100 KRW is charged per hole from hole 1 to 18.\n' +
          '  3) If a game is stopped midway, billing is based on the number of holes played.\n' +
          '2. Billing by product type:\n' +
          '  1) Practice C: Only 9-hole 20 courses available, free of charge.\n' +
          '  2) Combo A / Practice B: All content accessible; usage fees are charged per person per hole.\n' +
          '3. Payment methods:\n' +
          '  1) Default: Postpaid automatic bank transfer. Prepaid and overdue payment options available.\n' +
          '  2) The Business Owner must pay the total amount monthly; partial payments are not allowed.\n' +
          '  3) Postpaid: Charges from the previous month (1st–end) are auto-debited on the due date (twice a day).\n' +
          '  4) Prepaid: Payment via transfer or credit card at least 2 days before the due date.\n' +
          '  5) Overdue: Payment made manually after the due date.\n\n' +
          'Article 4 (Payment Method, Arrears Handling, and Product Change)\n' +
          '1. Two methods: Bank transfer or credit card.\n' +
          '2. Arrears:\n' +
          '  1) Services are suspended immediately after overdue.\n' +
          '  2) Daily interest applies from the date of arrears (0.n%).\n' +
          '  3) Service is restored upon payment.\n' +
          '3. Product changes take effect on the 1st of each month.\n\n' +
          'Article 5 (Unspecified Matters and Legal Priority)\n' +
          '1. Unspecified matters follow relevant laws and customs.\n' +
          '2. Consumer protection laws (e.g., E-Commerce Act) take precedence.\n' +
          '3. If individual terms exist, they take priority.\n\n' +
          'Article 6 (Disclaimer)\n' +
          '1. Not liable for force majeure such as natural disasters, war, or telecom outage.\n' +
          '2. Not liable for damages from maintenance or replacement.\n' +
          '3. Not liable for damage caused by store computer error or incorrect data.\n' +
          '4. Not liable for unmet expected profits or data use losses.\n' +
          '5. No obligation for prior review of posted content.\n' +
          '6. No liability for free services except in case of privacy violations.\n\n' +
          'Article 7 (Contract Termination, etc.)\n' +
          '1. In case of mutual termination or sale, prior notice and payment of outstanding amounts required before service recovery.\n' +
          '2. Late payment incurs statutory interest.\n' +
          '3. If partially used, the corresponding amount and costs can be charged.\n\n' +
          'Article 8 (Dispute Resolution)\n' +
          '1. Compensation handling department is operated.\n' +
          '2. Complaints and inquiries are prioritized; if delayed, reasons and schedule are provided.\n\n' +
          'Article 9 (Governing Law and Jurisdiction)\n' +
          '1. Governed by the laws of the Republic of Korea.\n' +
          '2. Jurisdiction follows the Civil Procedure Act.',

      privacyText:
          'Article 1 General Provisions\n' +
          'K-Golf Co., Ltd. ("Company") values the personal information provided by users while using the services offered through the store management site (https://kms.thekgolf.com). We comply with relevant laws (e.g., the Communications Privacy Protection Act, the Act on Promotion of Information and Communications Network Utilization, etc.) and provide a clear explanation of how personal information is collected and used through this Privacy Policy. This policy is subject to revision according to law or internal policy changes.\n\n' +

          'Article 2 Items Collected, Collection Methods, and Purpose of Use\n' +
          '(a) Items Collected\n' +
          '  1) For membership registration and service provision: Name, ID, mobile phone number, address, email (deleted upon withdrawal)\n' +
          '  2) For bank transfer payments: Bank name, account number, account holder (retained for 5 years)\n' +
          '  3) For virtual account: Bank name, depositor name (retained for 5 years)\n' +
          '  4) For credit card payments: Card company, card number, expiration date (retained for 5 years)\n' +
          '  5) For transaction records: IP address, cookies, access logs, usage history (deleted upon withdrawal)\n' +
          '  6) For events/delivery: Name, address, phone number (destroyed after purpose is achieved)\n' +
          '  7) For promotional materials: Name, address, phone number (destroyed after purpose is achieved)\n\n' +
          '(b) Purpose of Use\n' +
          '  1) Contract fulfillment and billing\n' +
          '  2) Member management, identity verification, preventing improper use, handling complaints\n' +
          '  3) New service development, marketing, statistics, advertising\n' +
          '  4) Individual notifications in case of service failures\n\n' +
          '(c) Retention Period\n' +
          '  - Retained during service use; destroyed upon request for deletion or withdrawal\n' +
          '  - Destroyed immediately after the purpose of collection is fulfilled (e.g., for events)\n' +
          '  - Records of users with violations are stored for 1 year from termination\n\n' +
          '(d) Collection Methods\n' +
          '  - Website, documents, fax, phone, bulletin board, email, events, cookie/log tools\n\n' +

          'Article 3 Procedure and Method for Disposal of Personal Information\n' +
          '(a) Disposal Procedure: Stored for a certain period according to internal policies and laws after the purpose is fulfilled, then destroyed.\n' +
          '(b) Disposal Method: Paper documents are shredded or incinerated; electronic files are deleted in an unrecoverable way.\n\n' +

          'Article 4 Provision and Sharing of Personal Information\n' +
          'Personal information will not be shared with third parties without prior consent.\n' +
          'However, exceptions apply in the following cases:\n' +
          '  - If the user has consented\n' +
          '  - For billing, service violation handling, or legal investigations\n\n' +

          'Article 5 Outsourcing of Processing\n' +
          'We outsource some services to professional companies for better service quality. The outsourcing contract specifies legal compliance and responsibility.\n' +
          '  - Outsourced tasks: Credit card payments, bank transfers, SMS → Settlebank\n\n' +

          'Article 6 User Rights\n' +
          'Users and legal representatives can request to view, edit, delete, or withdraw personal information through the website.\n\n' +

          'Article 7 Withdrawal of Consent\n' +
          'Consent (e.g., at sign-up) can be withdrawn immediately by written request, phone, or email.\n\n' +

          'Article 8 Cookie Usage\n' +
          'Cookies are used to provide customized services. Users can allow or block cookies in their browser settings. Blocking cookies may restrict some services.\n\n' +

          'Article 9 Protection Measures\n' +
          '  - Password protection, antivirus software, encryption, firewall systems\n' +
          '  - Limited access to authorized staff with regular training\n\n' +

          'Article 10 Protection of Children’s Information\n' +
          'For users under the age of 14, consent from a legal guardian is required.\n\n' +

          'Article 11 Marketing Information Transmission\n' +
          'Advertisements cannot be sent without explicit consent. If sent, "Advertisement" will be clearly labeled.\n\n' +

          'Article 12 Contact for Inquiries\n' +
          'Data Protection Officer: Haksoo Kim (Admin Division) +82-1577-0564 / kimhs@thekgolf.com\n' +

          'Article 13 Amendments\n' +
          'Effective Date: January 2, 2021',

      refundText:
          'These regulations apply when a consumer requests a refund for pre-paid content passes (e.g., monthly passes, usage passes, seasonal passes) purchased from K-Golf Co., Ltd. or affiliated stores, based on the usage period or count. They are managed in accordance with relevant laws, the Korea Fair Trade Commission’s Consumer Dispute Resolution Standards, and industry practices.\n\n' +

          'Article 1 (Reasons and Standards for Refunds)\n' +
          '1. If the consumer is responsible for the refund request:\n' +
          '  1) Before usage begins:\n' +
          '    - If the refund is requested within 7 days of payment: Full refund without penalty, based on Articles 17 and 18(9) of the E-Commerce Act.\n' +
          '    - If the refund is requested after 7 days: The right to withdraw is forfeited. Post-usage standards apply.\n' +
          '  2) After usage begins:\n' +
          '    - The amount equivalent to the used days or counts (based on the standard unit price) will be deducted and the remaining balance refunded.\n' +
          '    - A 10% cancellation fee (penalty) will be deducted from the remaining balance.\n\n' +

          '2. If the company is responsible for the refund:\n' +
          '  1) Before usage begins: Full refund of the payment amount.\n' +
          '  2) After usage begins: Full refund of the unused remaining amount (no cancellation fee).\n\n' +

          'Article 2 (Refund Procedure)\n' +
          '1. Submit a written request or contact the customer center.\n' +
          '2. If requested within 7 days from the payment date: Immediate full refund.\n' +
          '3. If requested after usage begins: The used amount is deducted and a 10% cancellation fee is applied. The refund will be processed within 7 business days.\n' +
          '4. The affiliated store sends the request to the head office for settlement and refund processing.\n\n' +

          'Article 3 (Refund Calculation Example)\n' +
          'Example: Monthly pass of 100$ with a 30-day usage period\n' +
          '  - If canceled after 10 days of use:\n' +
          '    · Used amount: 10 × 3.3$ = 33$ \n' +
          '    · Remaining balance: 100 – 33 = 67$ \n' +
          '    · Cancellation fee (10%): 6.7$ \n' +
          '    · Refund amount: 60.3$ (approx. 60$)\n\n' +

          'Article 4 (Customer Inquiries)\n' +
          'Refunds and inquiries: Customer Service +82-1577-0564\n\n' +

          'Article 5 (Legal Basis)\n' +
          '· Articles 17 and 18 of the “Act on the Consumer Protection in Electronic Commerce, etc.”\n' +
          '· Article 21 of the Enforcement Decree of the same Act\n' +
          '· “Consumer Dispute Resolution Standards” (KFTC Notice No. 2023-14)'
    },
    tournament: {
      list: {
        tournamentOpen: '대회 개설',
        tournamentId: '대회번호',
        title: '대회명',
        tournamentType: '개설타입',
        period: '기간',
        participantCount: '참가인원',
        courseCount: '코스갯수',
        modify: '수정',
        etc: '기타',
        expires01: 'Hệ thống giải đấu mới dự kiến sẽ được cập nhật vào tháng 7. \nSau khi cập nhật, người chơi sẽ có thể chọn tối đa bốn khóa học cho mỗi giải đấu.',
        expires02: 'Đối với các giải đấu được lên lịch trước khi cập nhật, vui lòng đặt ngày kết thúc chậm nhất là ngày 15 tháng 9 năm 2024.',

        modifyPossibility: '수정가능',
        modifyImpossibility: '수정불가',
        listDelete: '삭제하기',
        earlyTermination: '조기종료',
        awarding: '시상하기',
        awardAnnouncement: '시상발표',
        awardRecipientsView: '시상내역',

        statusFilter: {
          all: '전체',
          proceeding: '진행중',
          expected: '예정',
          end: '종료',
        },

        popup: {
          deleteTournamentConfirm: {
            text1: '선택한 대회를 삭제 하시겠습니까?',
            text2: '※ 삭제된 대회는 복구되지 않습니다.',

            requestSuccess: '대회를 삭제 하였습니다.',
            requestFail: '대회 삭제를 실패 하였습니다. \n다시 시도하시기 바랍니다.',
          },
          earlyEndTournamentConfirm: {
            text1: '현재 진행중인 대회를 지금 시간을 기준으로 종료를 진행 하시겠습니까?',
            text2: '※ 대회를 종료하게되면, 더 이상 대회에 참가할 수 없습니다.',
            text3: '단, 현재 대회를 진행중인 사용자는 진행 할 수 있습니다.',

            requestSuccess: '대회를 조기종료 하였습니다.',
            requestFail: '대회 조기종료를 실패 하였습니다. \n다시 시도하시기 바랍니다.',
          },
        },
      },

      open: {
        tournamentTerm: '대회 약관',
        acceptTerms: '약관 동의',

        participatingStoresSettingAlert: '10개만 개설할 수 있습니다',
        participatingStoresSetting: '참가 매장 설정',
        addParticipatingStore: '참가 매장 추가',
        country: '국가',
        province: '시 / 도',
        city: '시 / 군 / 구',
        participatingStore: '참가 매장',

        basicSetting: '기본 설정',
        tournamentTitle: '대회명',
        tournamentTitlePlaceholder: '대회명을 입력해주세요. (한글 20자, 영문 40자 이내)',
        tournamentTitleInvalidMessage: '대회명은 40자 이내로 입력해주세요.',
        tournamentIntroduce: '대회 소개',
        tournamentIntroducePlaceholder: '간략한 대회 소개 글을 입력해주세요. (한글 100자, 영문 120자 이내)\n※입력하지 않을 경우, 공란으로 표시됩니다.',
        tournamentIntroduceInvalidMessage: '대회 소개는 120자 이내로 입력해주세요.',
        tournamentSummary: '대회 요강',
        tournamentParticipantTerms: '참가자 이용약관',
        tournamentSummaryDefaultValue:
          '참여 횟수는 대회 기간 내 무제한 입니다.\n스코어가 동점일 경우 완료한 라운드 횟수, 마지막 라운드 시간 순으로 랭킹 우선 순위를 산정하게 됩니다. \n1인 1계정 사용하여 대회에 참가 가능합니다. 타인의 플레이에 관여하거나 타구를 진행한 경우 시상 자격이 박탈됩니다.\n대리 참가 또는 공인구 미사용, 성별 허위 기재, 스윙 영상이 없는 경우, 시스템 오류 등 정당하지 않은 방법으로 기록한 스코어는 경기운영위원회의 판단에 의해 기록 취소될 수 있습니다.\n기록이 취소된 아이디는 모든 시상 대상에서 제외됩니다.\n대회 종료 후 상위권 수상자분들께 개별적으로 시상식 참가 요청을 드릴 수 있으며, 대회의 공정성 확인을 위하여 시상식 참석 및 사진 촬영에 협조 부탁 드립니다.\n\n대회가 시작되어 참여한 회원이 있는 상태에서 대회 취소 및 대회 규정을 변경하여 회원과 분쟁이 발생한 경우 본사는 관여하지 않습니다.\n매장대회 개설자 (이하 "매장업주"라 합니다.)에게 책임이 있습니다. 회원의 권리보호와 분쟁을 막기 위해 신중하게 결정하시기 바랍니다',
        tournamentThumbnail: '대회 썸네일',

        participationTarget: '참가 대상',
        participationTargetDescription: '성별 및 연령 구분 없이 모두 참가 가능',
        addParticipationTarget: '참가 대상 추가',
        participationTargetLimitType: '제한 구분',
        participationTargetName: '구분 이름',
        participationTargetFullName: '참가 대상 구분 이름',
        participationTargetGender: '성별',
        participationTargetBirthYearLimit: '출생년도 제한',
        participationTargetType: '참가 대상 타입',
        participationTargetMinimumBirthYear: '최소 출생년도',
        participationTargetMaximumBirthYear: '최대 출생년도',
        participationTargetBirthYearMessage1: '시작 년도 보다 이전 년도를 선택할 수 없습니다.',
        participationTargetBirthYearMessage2: '종료 년도 보다 이후 년도를 선택할 수 없습니다.',
        participationTargetTeeBoxTypeSetting: '티 위치 설정',

        participationGrade: '참가 등급',

        participationConditions: '참가 조건',
        participationConditionsDescription: '기존 대화 기록 상관없이 모두 참가 가능',
        addParticipationConditions: '참가조건 추가',
        participationConditionsLimitType: '제한 구분',
        participationConditionsTournamentList: '대회 목록',
        participationConditionsRankingsLitmit: '순위 제한',
        participationConditionType: '참가 조건 타입',
        participationConditionsTournamentTitlePlaceholder: '대회를 검색해주세요.',

        participationPeriod: '참가 기간',

        participatePublic: '참가 방식',
        participatePublicPlaceholder: '비밀번호(숫자4자리)',

        public: '공개',
        nondisclosure: '비공개',

        courseSetting: '코스 설정',
        courseCount: '코스 갯수',
        courseCountUnit: '개',
        courseSelection: '코스 선택',
        courseNumber: 'No',
        courseTitle: '코스명',
        courseType: '코스 타입',
        courseDifficulty: '코스 난이도',
        greenDifficulty: '그린 난이도',
        longestHole: '롱기스트 홀',
        nearpinHole: '니어핀 홀',
        newPerio: '신페리오',
        outCourseHole: '전반 홀',
        inCourseHole: '후반 홀',

        gameSetting: '경기 설정',
        difficultyEasy: '쉬움',
        difficultyNormal: '보통',
        difficultyHard: '어려움',
        difficultyManual: '수동',
        courseStartOrder: '코스 시작 순서',
        courseStartValue1: '전반 홀 > 후반 홀',
        courseStartValue2: '후반 홀 > 전반 홀',
        userDifficulty: '사용자 난이도',
        swingPlate: '스윙 플레이트',
        mulliganCount: '멀리건 횟수',
        windPower: '바람 세기',
        holeCupPosition: '홀컵 위치',
        greenPosition: '그린 위치',
        concede: '컨시드',
        greenSpeed: '그린 빠르기',
        puttingLineCount: '퍼팅 라인 횟수',
        greenHardness : '그린 경도',
        teeBox: '티 위치',
        guideDistance: '공략 거리',

        participantHandicap: '참가자 핸디캡',
        calibrationGrade: '등급별 보정',
        userGrade: '회원등급',
        scoreCorrection: '스코어 보정',
        calibrationParticipant: '참가 대상별 보정',

        rankingCriteria: '랭킹 책정 기준',
        rankingCriteriaDescription1: '랭킹 책정 기준 설정이란?',
        rankingCriteriaDescription2: '동위 타수가 복수명 일 때, 해당 동위 타수의 랭킹 순서를 정하는 기준을 설정하는 것을 말합니다.',
        rankingCriteriaOne: '1순위',
        rankingCriteriaGameRoundCount: '게임 기록 많은 순',
        rankingCriteriaGameRoundCountButton: '게임 기록 많은 순이란?',
        rankingCriteriaGameRoundCountDescription: 'Khi điểm số bằng nhau, người chơi hoàn thành nhiều vòng 18 hố hơn sẽ được xếp hạng cao hơn..',
        rankingCriteriaTwo: '2순위',
        rankingCriteriaOrderByGameRoundDesc: '게임 기록 많은 순',
        rankingCriteriaCountbackDescription: '대회 각 코스별 등록된 라운드의 9홀 합, 6홀 합, 3홀 합, 마지막 홀 합 순서로 백카운트를 계산합니다. 이 백카운트 계산은 합산 랭킹에만 적용됩니다.',
        rankingCriteriaThree: '3순위',
        rankingCriteriaBackCount: '백 카운트 방식 사용',
        rankingCriteriaBackCountButton: '백 카운트 방식이란?',
        rankingCriteriaLastRoundStartTime: 'Thời gian bắt đầu vòng cuối cùng',
        rankingCriteriaLastRoundStartTimeDescription: 'Khi điểm số và thành tích trận đấu bằng nhau, người chơi gần đây nhất dựa trên thời gian bắt đầu của vòng đấu cuối cùng đã hoàn thành 18 lỗ sẽ được đăng ký ở thứ hạng cao hơn.',
        rankingCriteriaUse: '사용',
        rankingCriteriaUnused: '미사용',

        awardSetting: '시상 설정',
        addAward: '시상내역 추가',
        awardName: '시상 이름',
        awardNamePlaceholder: '시상 이름을 입력하세요.',
        awardGender: '성별 구분',
        awardGenderAll: '구분 없음',
        awardItem: '시상 항목',
        awardType: '시상 타입',
        awardCourse: '코스 구분',
        awardCourseTotal: '코스 종합',
        awardRankingType: '순위 구분',
        awardSingleRanking: '단일 순위',
        awardRanegeRanking: '범위 순위',
        awardRankingRange: '순위 범위',
        awardRankingPlaceholder: '순위를 입력하세요.',
        awardRankingRangeText1: '부터',
        awardRankingRangeText2: '까지',
        awardProduct: '시상 상품',
        awardProductPlaceholder: '시상 상품을 입력하세요.',

        whetherLimit: '제한 여부',
        unLimit: '제한 없음',
        delete: '삭제',
        all: '전체',
        yearUnit: '년',
        yearRangeText1: '부터',
        yearRangeText2: '까지',

        save: '저장',
        modify: '수정',

        navigation: {
          step1: '약관 동의',
          step2: '대회 설정',
          step3: '대회 개설',
        },

        popup: {
          courseSelection: {
            title: '대회 코스 선택',
            courseSearch: '코스 검색',
            courseSearchPlaceholder: '코스를 검색해주세요.',
            selection: '선택',
            save: '저장',
            cancel: '닫기',

            message1: '더이상 코스를 선택할 수 없습니다.',
            message2: '코스를 선택해주세요.',
          },
          rankingCriteriaGameRoundCount: {
            text1: '개최된 대회에 참가하여 해당 코스를 완료한 기록이 더 많은 사용자를 상위 랭킹에 등록하는 기능',
            cancel: '닫기',
          },
          rankingCriteriaBackCount: {
            text1: '사용자의 스코어를 전반홀/후반홀로 나눈다.',
            text2: '※ 여기서의 전반홀과 후반홀은 먼저 친 9개의 홀이 전반홀, 나중에친 9개의 홀이 후반홀이 된다.',
            text3: '홀번호가 10홀 이라고 해서 후반홀이 되지 않는다.',
            text4: '후반 (9홀) 총 스코어가 더 좋은 사용자의 랭킹이 더 높게 된다.',
            text5: '- 가장 마지막에 친 홀부터 9홀',
            text6: '후반 (6홀) 총 스코어가 더 좋은 사용자의 랭킹이 더 높게 된다.',
            text7: '- 가장 마지막에 친 홀부터 6홀',
            text8: '후반 (3홀) 총 스코어가 더 좋은 사용자의 랭킹이 더 높게 된다.',
            text9: '- 가장 마지막에 친 홀부터 3홀',
            text10: '가장 마지막에 친 홀의 스코어를 각각 비교하여 스코어가 더 좋은 사용자의 랭킹이 더 높게 책정 된다.',
            cancel: '닫기',
          },
          shopTournamentOpenConfirm: {
            text1: '작성된 내용으로 대회를 개설 하시겠습니까?',
            text2: '개설된 대회는 대회 리스트에서 조회 및 수정이 가능 합니다.',

            title: '이미 사용 중인 대회명입니다. 다른 대회명을 입력해주세요.',

            requestSuccess: '매장 대회 개설 완료되었습니다.',
            requestFail: '매장 대회 개설 중 오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.',
          },
          shopTournamentModifyConfirm: {
            text1: '작성된 내용으로 대회를 수정 하시겠습니까?',

            title: '이미 사용 중인 대회명입니다. 다른 대회명을 입력해주세요.',

            requestSuccess: '매장 대회 수정 완료되었습니다.',
            requestFail: '매장 대회 수정 중 오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.',
          },
        },

        alert: {
          message1: '참가 대상의 경우 최소 1개 이상 입력해야합니다.',
          message2: '핸디캡은 -99에서 99 사이 값만 입력 가능',
          message3: '대회 시작 시간은 현재 시간 기준 24시간 이후로 입력해야합니다.',
          message4: '대회 기간은 최대 1년까지만 설정 가능합니다.',
          message5: '코스설정이 비어있습니다. 코스설정에 내용을 기입하시기 바랍니다.',
          message6: '시상설정이 비어있습니다. 시상설정에 내용을 기입하시기 바랍니다.',
          message7: '시작순위를 작게하세요.',
          message8: '비밀번호는 숫자 4자리를 입력 해야 합니다.',
          message9: '설정한 순위에 오류가 있습니다. 확인 부탁드립니다.\n예: -1, 0 같은 숫자는 들어 갈 수 없습니다.',
          message10: '시상 이름을 입력해 주세요.',
          message11: '대회명을 입력 해주세요.',
          message12: '추가한 시상내역의 시상 항목을 설정 부탁드립니다.',
          message13: 'Vui lòng kiểm tra số lượng khóa học và chọn khóa học',
        },

        isParticipationGrade: '등급사용 여부',
        participationGradeText1:
          '등급 사용시 <img src="/images/icon/ui_icon_grade_0_0.png" alt="grade" class="icon_grade" /><img src="/images/icon/ui_icon_grade_1_0.png" alt="grade" class="icon_grade" /> 등급회원은 대회참가를 할 수 없습니다.',
        participationGradeSelectTitle: '참가대상',
        participationGradeSelectNoUse: '제한없음',
        participationGrade2: '브론즈',
        participationGrade3: '실버',
        participationGrade4: '골드',
        participationGrade5: '플래티넘',
        participationGrade6: '다이아몬드',
        participationKHandiText6: '-0.1 이하 (언더 유저)',
        participationKHandiText5: '0.0 이상 ~ +7.9 이하 (싱글 유저)',
        participationKHandiText4: '+8.0 이상 ~ +17.9 이하 (80 유저)',
        participationKHandiText3: '+18.0 이상 ~ 27.9 이하 (90타 유저)',
        participationKHandiText2: '+28.0 이상 ~  (100타 이상 유저)',
        participationGradeText6_3: 'Diamond 등급 전체 10% 이하',
        participationGradeText6_2: 'Diamond 등급 전체 10% 초과 ~ 30% 이하',
        participationGradeText6_1: 'Diamond 등급 전체 30% 초과 ~',
        participationGradeText5_3: '핸디 0.0 이상 ~ 2.0 이하',
        participationGradeText5_2: '핸디 2.1 이상 ~ 5.0 이하',
        participationGradeText5_1: '핸디 5.1 이상 ~ 7.9 이하',
        participationGradeText4_3: '핸디 8.0 이상 ~ 10.0 이하',
        participationGradeText4_2: '핸디 10.1 이상 ~ 14.0 이하',
        participationGradeText4_1: '핸디 14.1 이상 ~ 17.9 이하',
        participationGradeText3_3: '핸디 18.0 이상 ~ 20.0 이하',
        participationGradeText3_2: '핸디 20.1 이상 ~ 24.0 이하',
        participationGradeText3_1: '핸디 24.1 이상 ~ 27.9 이하',
        participationGradeText2_3: '핸디 28.0 이상 ~ 38.0 이하',
        participationGradeText2_2: '핸디 38.1이상 ~ 48.0 이하',
        participationGradeText2_1: '핸디 48.1이상 ~',
        calibration: '보정치',
        kHandi: 'K Handi',
        criteria: '기준',
        notAllowed: '참가불가',
      },

      details: {
        tab: {
          summary: '대회 요강',
          information: '대회 정보',
          ranking: '대회 랭킹',
          award: '대회 시상',
          awardHistory: '시상 내역',
          participantTerms: '참가자 이용약관',
          participatingStoresList: '참가 매장 리스트',
        },

        information: {
          introduce: '대회 소개',

          tournamentPeriod: '대회 기간',
          participatePublic:'참가 방식',

          participationTarget: '참가 대상',
          participationNoLimit: '제한 없음',
          participationTargetName: '구분 이름',
          participationTargetFullName: '참가 대상 구분 이름',
          participationTargetMinimumBirthYear: '최소 출생년도',
          participationTargetMaximumBirthYear: '최대 출생년도',
          participationTargetTeeBoxSetting: '티 위치 설정',

          participationGrade: '참가 등급',
          gradeParticipationAvailability: '참가 가능 여부',
          participationPossible: '참가 가능',
          unableParticipate: '참가 불가능',

          participationConditions: '참가 조건',
          participationConditionTournamentName: '대회명',
          participationConditionRankingLimit: '순위 제한',

          tournamentCourse: '대회 코스',
          courseNumber: '코스 번호',
          courseName: '코스 이름',
          courseLongest: '롱기스트',
          courseNearpin: '니어핀',
          sinperioExclusionHall: '신페리오 제외 홀',

          userDifficulty: '사용자 난이도',
          swingPlate: '스윙 플레이트',
          mulliganCount: '멀리건 횟수',
          windPower: '바람 세기',
          holeCupPosition: '홀컵 위치',
          greenPosition: '그린 위치',
          concede: '컨시드',
          greenSpeed: '그린 빠르기',
          puttingLineCount: '퍼팅 라인 횟수',
          teeBox: '티 위치',
          greenHardness: '그린 경도',
          calibrationGrade: '등급별 보정',
          guideDistance: '공략 거리',

          calibrationParticipant: '참가 대상별 보정',

          awardItem: '시상 항목',
          awardName: '시상 이름',
          awardType: '시상 타입',
          awardCourse: '코스 구분',
          awardRankingType: '순위 구분',
          awardSingleRanking: '단일 순위',
          awardRanegeRanking: '범위 순위',
          awardRankingRange: '순위 범위',
          awardRankingUnit: '등',
          awardProduct: '시상 상품',
          awardNone: '없음',
          awardAll: '전체',

          awardAnnouncement: '수상자 발표하기',
          scoreCorrection: '스코어 보정',
          genderNoLimit: '무관',
          participationGradeTitle: '참가대상 및 보정정보',
        },

        participatingStoresList: {
          country: '국가',
          province: '시 / 도',
          city: '시 / 군 / 구',
          participatingStore: '참가 매장',
          all: '전체',
        },

        ranking: {
          courseTotalScore: '총 스코어',
          searchTextBoxPlaceholder: '닉네임을 입력해주세요.',

          allRanking: '전체 순위',
          allRankingOption1: '순위 높은순',
          allRankingOption2: '순위 낮은순',
          allRankingOptionReset: '초기화',

          genderRanking: '성별 순위',
          genderRankingOption1: '여성만',
          genderRankingOption2: '남성만',
          genderRankingOptionAll: '전체',

          nickname: '닉네임',
          participationCount: '참가 횟수',
          teeBoxLocation: '티박스 위치',
          totalDistance: '비거리 (m)',
          remainDistance: '남은거리 (m)',
          recordTime: '달성 시간',
          lastRoundStartTime: '마지막 라운드 시작 시간',
          newPerioScoreRecord: '12홀 성적',
          finalScore: '최종 스코어',
          birdieCount: '버디 횟수',
          eagleCount: '이글 횟수',
          courseName: '코스 이름',
          holeNumber: '홀 번호',
          courseDistance: '전장 거리',
          totalParticipationCount: '총 참가 횟수',
          gradeRankingOption1: '높은순',
          gradeRankingOption2: '낮은순',
          handicap: '핸디캡',
        },

        awardRanking: {
          allChoice: '전체 선택',
          awardConfirmation: '시상 확정',
          resetAwards: '시상 초기화',
          awardRecipientsSelection: '수상자 선정',

          courseScore: '코스 스코어',
          handicap: '핸디캡',
          additionalHandicap: '추가 핸디캡',
          adjustmentResult: '조정 결과',
          adjustmentSynthesis: '조정 종합',
          finalScore: '최종 스코어',
          courseOverall: '코스 종합',
          swingVideo: '스윙 영상',
          videoPlay: '영상 재생',

          alert: {
            message1: '추가 핸디캡은 -99에서 99사이의 숫자만 입력 가능',
          },
        },

        awardHistory: {
          rankingUnit: '위',

          ranking: '순위',
          nickname: '닉네임',
          record: '기록',
          recordTime: '달성 시간',
          totalParticipationCount: '총 참가 횟수',
          courseName: '코스 이름',
          holeNumber: '홀 번호',
        },

        course: 'Khóa',
        summation: 'sự tính tổng',
        gender: '성별',
        grade: '참가시 등급',
        startGrade: 'lớp bắt đầu',
        lastGrade: 'lớp cuối cùng',
        handicapGrade: 'cấp',
        storeUse: '이용 매장',
        public: '공개',
        nondisclosure: '비공개',

        alert: {
          message1: '대회 종료 후 24시간이 지나야 접근 가능',
          message2: '대회 수상자 선정 후 시상내역 보기 가능',
        },

        popup: {
          resetTournamentAwardsConfirm: {
            text1: '시상 초기화를 진행하시겠습니까?',
            text2: '시상 초기화를 진행하면, 현재 등록된 추가 핸디캡 및 시상 확정 내역이 모두 초기화 됩니다.',

            requestSuccess: '시상내역을 모두 초기화 하였습니다.',
            requestFail: '시상내역 초기화에 실패 하였습니다. \n다시 시도하시기 바랍니다.',
          },

          tournamentAwardRecipientsSelectionConfirm: {
            text1: '현재 등록된 시상확정을 기준으로 수상자를 선정 하시겠습니까?',
            text2: '등록된 내용은 시상내역 페이지에서 확인 할 수 있습니다.',
            text3: 'Một khi người chiến thắng đã được công bố, thứ hạng không thể thay đổi.',
            text4: 'Để sửa đổi thứ hạng, bạn phải ‘Khởi tạo giải thưởng’ trước khi thực hiện bất kỳ điều chỉnh nào.',

            requestSuccess: '수상자 선정이 완료 되었습니다. \n수상자는 시상내역 페이지에서 확인 할 수 있습니다.',
            requestFail: '수상자 선정이 실패 되었습니다. \n다시 시도해 주시기 바랍니다.',
          },

          tournamentAwardAnnouncementConfirm: {
            text1: '수상자를 발표하면 더 이상 수상자를 수정 할수 없습니다.',
            text2: '수상자 발표를 진행 하시겠습니까?',

            requestSuccess: '수상자 발표가 완료 되었습니다.',
            requestFail: '수상자 발표에 실패 하였습니다.',
          },
        },
      },

      awardItem: {
        Score: '스코어',
        Longest: '롱기스트',
        Nearpin: '니어핀',
        HoleInOne: '홀인원',
        CourseRoundPlayCount: '라운딩 횟수',
      },
      awardType: {
        Stroke: '스트로크',
        NewPerio: '신페리오',
        BirdieCount: '버디 횟수',
        EagleCount: '이글 횟수',
      },
    },
    control: {
      image: {
        delete: '삭제하기',
        fileSelect: '파일선택',
      },
    },
    contentsItem: {
      info: {
        prevItem: '이전 구매 콘텐츠 정보',
        prevItemText: '더 이상 구매할 수 없는 콘텐츠 이용권 입니다. <br/>구매를 원하실 경우 서비스 운영팀으로 문의 주세요.',
        itemText: '본 상품은 구매 후 자동으로 적용됩니다.',
        alertMsgTitle: '콘텐츠 사용 안내',
        alertMsgSubTitle: '사용중인 콘텐츠',
        alertMsgUser: '안녕하세요. {user}님.',
        paymentMsg: '구매하신 콘텐츠 이용권이 다음과 같이 적용되었습니다.',
        paymentTitle: '결제 수단 선택',
      },
      button: {
        payment: '구매하러 가기',
        purchase: '구매하기',
        rePurchase: '재 구매하기',
        creditCard: '신용카드',
        cash: '계좌이체',
        paypal: 'PayPal',
      },
      shopSupplyItem: {
        salesCode:'자재코드'
      },
      1010110110: {
        title: '콘텐츠 이용권(기간제)',
        icon: '/itemImage/ui_icon_period.png',
        unit: 'DAYS',
        itemInfo: '매장 기기',
        itemDescription: '{count}일 동안 게임 콘텐츠를 사용 할 수 있는 콘텐츠 이용권(기간제)입니다.',
        itemPayment: '{count}일이 추가되어 {newCount}일 만큼 콘텐츠 사용이 가능합니다.',
        alertMsg: '매장에서 사용중인 콘텐츠 이용권(기간제)가 {count}일 후에 모두 소진될 예정입니다. 원활한 콘텐츠 사용을 위해 콘텐츠 이용권(기간제)을 구매해 주세요.',
        alertMsgNone: '매장에서 사용중인 콘텐츠 이용권(기간제)가 모두 소진되었습니다. \n콘텐츠 이용권(기간제)가 없을 경우 새로운 게임을 진행 할 수 없습니다. \nShop으로 이동하여 콘텐츠 이용권(기간제)을 구매해 주세요.',
      },
      1010120110: {
        title: '콘텐츠 이용권(홀)',
        icon: '/itemImage/ui_icon_round.png',
        unit: 'HOLE',
        itemDescription: '{count}홀 회수만큼 게임 콘텐츠를 사용 할 수 있는 콘텐츠 이용권(홀)입니다.',
        itemPayment: '{count}홀이 추가되어 {newCount}홀 만큼 콘텐츠 사용이 가능합니다.',
        alertMsg: '매장에서 사용중인 콘텐츠 이용권(홀)이 {count}홀 남았습니다. 원활한 콘텐츠 사용을 위해 콘텐츠 이용권(홀)을 구매해 주세요.',
        alertMsgNone: '매장에서 사용중인 콘텐츠 이용권(홀)이 {count}홀 남았습니다. \n콘텐츠 이용권(홀)이 {round}홀 이하가 될 경우 새로운 게임을 진행 할 수 없게 됩니다. \nShop으로 이동하여 콘텐츠 이용권(홀)을 구매해 주세요.',
      },
      alertMsg: {
        all: '매장에서 사용중인 콘텐츠 이용권(기간제)가 {day}일, 콘텐츠 이용권(홀)이 {count}홀 플레이 후 모두 소진될 예정이오니 원활한 콘텐츠 사용을 위해 콘텐츠 이용권(기간제), 콘텐츠 이용권(홀)을 구매해주세요.',
        allNone: '매장에서 사용중인 콘텐츠 이용권(기간제)이 {day}일, 콘텐츠 이용권(홀)이 {round}홀 이하가 되었습니다. \n콘텐츠  이용권이 부족할 경우 새로운 게임을 진행 할 수 없습니다. \nShop으로 이동하여 콘텐츠 이용권을 구매해 주세요.',
      },
      // 소모품 구매
      51101511111011: {
        title: 'Mat BGS Type Stance Mat',
        icon: '/itemImage/KGFMAT001012.jpg',
        unit: 'ea',
        itemDescription: 'Stance Mat with rubber base included, size 1100x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100061',
      },
      51101511111012: {
        title: 'Mat BGS Type (Left/Right) Fairway Mat Set',
        icon: '/itemImage/KGFMAT001013.jpg',
        unit: 'set',
        itemDescription: 'All-in-one mat set with fairway, rough, bunker, and rubber base, 600x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100062',
      },
      51101511111013: {
        title: 'Mat BGS Type Cut-Out Fairway Mat',
        icon: '/itemImage/KGFMAT002015.jpg',
        unit: 'ea',
        itemDescription: 'Fairway mat with rough and bunker cut-outs, Velcro bottom, 600x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100081',
      },
      51101511111014: {
        title: 'Mat BGS Type Fairway Mat',
        icon: '/itemImage/KGFMAT002016.jpg',
        unit: 'ea',
        itemDescription: 'Fairway mat with top and two-tone turf, size 370x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100082',
      },
      51101511111015: {
        title: 'Mat BGS Type Rubber base',
        icon: '/itemImage/700004.jpg',
        unit: 'ea',
        itemDescription: 'Rubber base with cut-outs for bunker and rough, size 600x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100073',
      },
      51101511111016: {
        title: 'Mat BGS Type Rough Mat',
        icon: '/itemImage/KGFMAT002001.jpg',
        unit: 'ea',
        itemDescription: 'Rough Mat with velcro on bottom, size 400x230mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100067',
      },
      51101511111017: {
        title: 'Mat BGS Type Grey Bunker Mat',
        icon: '/itemImage/KGFMAT002017.jpg',
        unit: 'ea',
        itemDescription: 'Gray Bunker Mat with velcro on bottom, size 400x230mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100083',
      },
      51101511111018: {
        title: 'Mat BGS Type Silver Brush Bunker Mat',
        icon: '/itemImage/KGFMAT001011.jpg',
        unit: 'ea',
        itemDescription: 'Silver Brush Bunker Mat with Velcro on steel bottom surface, size 400x230mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100060',
      },
      51101512111011: {
        title: 'Mat KDR Type Stance Mat',
        icon: '/itemImage/KGFMAT001015.jpg',
        unit: 'ea',
        itemDescription: 'Stance Mat with rubber base, size 1000 x 1000mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100064',
      },
      51101512111012: {
        title: 'Mat KDR Type Fairway Mat',
        icon: '/itemImage/KGFMAT001017.jpg',
        unit: 'ea',
        itemDescription: 'Fairway Mat with rubber base and two-tone turf, size 500x1000mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '100066',
      },
      51101513111011: {
        title: 'Auto Tee Type  Auto Tee up System',
        icon: '/itemImage/100175.jpg',
        unit: 'ea',
        itemDescription: 'Built-in auto tee-up system set with integrated floor keypad included.<br />* You can check the order status in the payment management menu.',
        salesCode: '100175',
      },
      51101514111012: {
        title: 'Consumables Type Rubber Tee',
        icon: '/itemImage/100187.jpg',
        unit: 'ea',
        itemDescription: 'Rubber Tee, (JE)<br />* You can check the order status in the payment management menu.',
        salesCode: '100187',
      },
      51101514111013: {
        title: 'Consumables Type Rubber Tee (Moving Swing Plate)',
        icon: '/itemImage/100188.jpg',
        unit: 'ea',
        itemDescription: 'Rubber tee for swing plate, compatible with JE auto tee-up system.<br />* You can check the order status in the payment management menu.',
        salesCode: '100188',
      },
      51101517700001: {
        title: 'Mat BGS Type Fairway Mat',
        icon: '/itemImage/700001.jpg',
        unit: 'ea',
        itemDescription: 'Fairway mat with two-tone turf, Velcro bottom, size 370x1040mm<br />* You can check the order status in the payment management menu.',
        salesCode: '700001',
      },
      51101517700002: {
        title: 'Mat BGS Type Fairway Extension Mat 1',
        icon: '/itemImage/700002.jpg',
        unit: 'ea',
        itemDescription: 'Extension panel for fairway mat. Velcro bottom. 230x240mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '700002',
      },
      51101517700003: {
        title: 'Mat BGS Type Fairway Extension Mat 2',
        icon: '/itemImage/700003.jpg',
        unit: 'ea',
        itemDescription: 'Extension panel for fairway mat. Velcro bottom. 260×600mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '700003',
      },
      51101517700004: {
        title: 'Mat BGS Type Fairway Mat Rubber base',
        icon: '/itemImage/700004.jpg',
        unit: 'ea',
        itemDescription: 'Rubber base for fairway set, Velcro top, size 600x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '700004',
      },
      51101517700005: {
        title: 'Mat BGS Type Rough Mat',
        icon: '/itemImage/700005.jpg',
        unit: 'ea',
        itemDescription: 'Rough Mat with Velcro bottom, size 400x230mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '700005',
      },
      51101517700007: {
        title: 'Mat BGS Type Stance Mat',
        icon: '/itemImage/700007.jpg',
        unit: 'ea',
        itemDescription: 'Stance Mat with rubber  bottom, size 1100x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '700007',
      },
      51101517700009: {
        title: 'Mat BGS Type Fairway Set (Right Hand)',
        icon: '/itemImage/700009.jpg',
        unit: 'ea',
        itemDescription: 'Right-Handed all-in-one mat set with fairway, rough, bunker, and rubber base, 600x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '700009',
      },
      51101517700010: {
        title: 'Mat BGS Type Fairway Set (Left Hand)',
        icon: '/itemImage/700010.jpg',
        unit: 'ea',
        itemDescription: 'Left-Handed all-in-one mat set with fairway, rough, bunker, and rubber base, 600x1300mm.<br />* You can check the order status in the payment management menu.',
        salesCode: '700010',
      },
      51101517100175: {
        title: 'Auto Tee Type Auto Tee up System(Right Hand)',
        icon: '/itemImage/100175.jpg',
        unit: 'ea',
        itemDescription: 'Right-Handed built-in auto tee-up system set with integrated floor keypad included.<br />* You can check the order status in the payment management menu.',
        salesCode: '100175',
      },
      51101517100176: {
        title: 'Auto Tee Type Auto Tee up System (Left Hand)',
        icon: '/itemImage/100176.jpg',
        unit: 'ea',
        itemDescription: 'Left-Handed Built-in auto tee-up system set with integrated floor keypad included.<br />* You can check the order status in the payment management menu.',
        salesCode: '100176',
      },
      51101517100222: {
        title: 'Mat BGS Type Bunker Mat',
        icon: '/itemImage/100222.jpg',
        unit: 'ea',
        itemDescription: 'Brush Bunker Mat on steel bottom surface with Velcro, size 400x230mm. <br />* You can check the order status in the payment management menu.',
        salesCode: '100222',
      },
      51101514111011: {
        title: 'Consumables Type Rubber Tee',
        icon: '/itemImage/100186.jpg',
        unit: 'ea',
        itemDescription: 'Rubber Tee, (CT&G)<br />* You can check the order status in the payment management menu.',
        salesCode: '100186',
      },
      51101514111014: {
        title: 'Consumables Type Marking Golf Balls',
        icon: '/itemImage/KGFBAL001001.jpg',
        unit: 'box',
        itemDescription: 'Marked with 4-dot pattern, 1 box includes 300 balls.<br />* You can check the order status in the payment management menu.',
        salesCode: '100166',
      },

    },
  },
};
